import { Route, Routes } from "react-router-dom"

import { HomeEntry } from "@/pages/HomeEntry"
import { LandingPage } from "@/pages/marketing/LandingPage"
import { NotFoundPage } from "@/pages/NotFoundPage"
import { PrivacyPolicyPage } from "@/pages/marketing/PrivacyPolicyPage"
import { RequestAccessPage } from "@/pages/marketing/RequestAccessPage"
import { TermsPage } from "@/pages/marketing/TermsPage"

/** Every route here is public and prerendered (see
 *  `scripts/prerender-marketing.mjs`); links into the product go through
 *  `appUrl()` rather than a route, because the app is its own deployment. */
export default function App() {
  return (
    <Routes>
      <Route index element={<HomeEntry />} />
      <Route path="home" element={<LandingPage />} />
      <Route path="request-access" element={<RequestAccessPage />} />
      <Route path="legal/privacy" element={<PrivacyPolicyPage />} />
      <Route path="legal/terms" element={<TermsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
